import { z } from 'zod';

export const carRiderFormSchema = z.object({
  student: z.number().min(1, 'Student is required'),
  school: z.number().min(1, 'School is required'),
  status: z.enum(['waiting', 'called', 'picked_up', 'cancelled']),
  queued_at: z.string().min(1, 'Queued At is required'),
  notes: z.string().optional(),
});

export const pickupDelegationFormSchema = z.object({
  student: z.number().min(1, 'Student is required'),
  school: z.number().min(1, 'School is required'),
  delegate_name: z.string().min(1, 'Delegate Name is required'),
  delegate_phone: z.string().optional(),
  delegate_email: z.string().optional().refine(
    (val) => !val || z.string().email().safeParse(val).success,
    { message: 'Invalid email address' }
  ),
  relationship: z.string().optional(),
  valid_from: z.string().min(1, 'Valid From is required'),
  valid_until: z.string().nullable().optional(),
  is_active: z.boolean().optional(),
  notes: z.string().optional(),
});
